import { focusSearchBox } from '~/components/search-and-results/SearchFlightForm/SearchBoxUtils'
import { DataLayerObject, pushEventToDataLayer } from '~/utils/googleTagManager'

export function trackCtaClick(destinationAirportCode: string) {
  focusSearchBox('fromLocation')
  pushEventToDataLayer('navigation', {
    nav_element: 'card',
    nav_type: 'cta',
    nav_action: 'trending destinations',
    flight_to: destinationAirportCode,
  } as DataLayerObject)
}
